

function Transparency() {

    return (
        <div className="bg-white h-home flex justify-center p-8 flex flex-col items-center text-white">
            <div className="max-w-6xl mx-auto text-left w-full">

                <h2 className="text-3xl md:text-4xl text-blue-900 font-bold mb-6">Nosso portal de Transparência</h2>

                <p className="text-base md:text-lg mb-8 text-blue-900 leading-relaxed">
                    A Associação Keralty acredita firmemente na importância da total transparência em suas ações. Todos os nossos relatórios financeiros detalhados e de atividades completas estão disponíveis gratuitamente para download, garantindo que você acompanhe de forma clara e objetiva como suas doações são efetivamente transformadas em um impacto real e positivo na comunidade.
                </p>
                <p className="text-base md:text-lg mb-8 text-blue-900 leading-relaxed">
                    📌 Destaque
                    "Em 2024, graças às doações, atendemos mais de 10.000 pessoas. Cada contribuição faz parte dessa transformação." (DADOS FICTÍCIOS, PRECISAMOS CONFIRMAR)        </p>
            </div>
            <button className="bg-primary rounded-full font-bold font-rubil px-10 py-4 hover:text-primary hover:bg-slate-100">Relatório 2025.1</button>
        </div>
    )

}

export default Transparency;